<div>
  <div>
    <div fxLayout="column" fxLayoutAlign="center center" class="m-1">
      <mat-button-toggle-group #group="matButtonToggleGroup" [value]="toggleFutureEvents"
        (change)="onToggleChange($event)">
        <mat-button-toggle value="future">
          <span>{{ 'FUTURE-VISITS.FUTURE-VISITS' | translate}}</span>
        </mat-button-toggle>
        <mat-button-toggle value="history">
          <span>{{ 'FUTURE-VISITS.HISTORY' | translate}}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <mat-card>
      <mat-card-header>
        <mat-card-subtitle>
          <h3 class="mx-2 mb-2">{{customerName}}</h3>
        </mat-card-subtitle>
        <div fxFlex fxLayoutAlign="end">
          <button mat-stroked-button (click)="back()">
            <mat-icon color="primary" matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
            {{ 'FUTURE-VISITS.BACK' | translate}}</button>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="column">
          <div class="content" perfectScrollbar>

            <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" *ngIf="dataSource.data.length > 0">
              <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef>                   
                  <ng-container *ngIf="column == 'details'">
                    {{'FUTURE-VISITS.DETAILS' | translate}}
                  </ng-container>
                  
                  <ng-container *ngIf="column == 'date'">
                    <div fxLayoutAlign="center center">{{'TIME.DATE' | translate }}</div>
                  </ng-container>
                  
                  <ng-container *ngIf="column == 'symbol'"></ng-container>                  
                </th>
                <td mat-cell *matCellDef="let element" class="pt-2 pb-2"> 
                  <ng-container *ngIf="column == 'details'">
                    <div fxLayout="column" (click)="element.ExpendDetails = !element.ExpendDetails">
                      <div><b>{{element.SchedulerName}}</b></div>
                      <div fxLayoutAlign="start center">                    
                        <span *ngIf="visitReasonSummary(element) else noPermissionTemplate">{{ visitReasonSummary(element) }}</span>
                        <ng-template #noPermissionTemplate>
                          <div>{{ 'COMMON.NO-PERMISSION' | translate }}</div>
                        </ng-template>
                        <span class="m-1">|</span><span>{{element.Duration}}</span>
                        <span class="m-1">{{'TIME.MINS' | translate }}</span>
                      </div>
                      <div>{{element.BusinessName}}</div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="column == 'date'">
                    <div fxLayout="column" fxLayoutAlign="center center" (click)="element.ExpendDetails = !element.ExpendDetails">
                      <span>{{element.StartAt | amDateFormat: 'L'}}</span>
                      <span>{{element.StartAt | amDateFormat: 'ddd'}}</span>
                      <span>{{element.StartAt | amDateFormat: 'LT'}}</span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="column == 'symbol'">
                    <div *ngIf="toggleFutureEvents === 'future'">
                      <button mat-icon-button color="primary" (click)="editAppointment(element)"
                        *ngIf="!element.ReadOnly">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button color="primary" (click)="delete(element)" *ngIf="!element.ReadOnly" [disabled]="!canBeDeleted(element)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <div *ngIf="toggleFutureEvents === 'history'">
                      <button mat-raised-button color="accent" (click)="bookAppointment(element)" [disabled]="!canBookAppointment(element)">
                        {{ 'FUTURE-VISITS.BOOK-APPOINTMENT' | translate }}
                      </button>
                    </div>
                  </ng-container>
                 
                </td>
              </ng-container>
             
              <!-- Expanded Content -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="pt-2 pb-2">
                  <div class="element-detail" 
                  [@detailExpand]="element.ExpendDetails ? 'expanded' : 'collapsed'" 
                  [ngClass]="{'even-row': element.even, 'odd-row': !element.even}">
                    <ng-container *ngIf="element && element.Treatments">
                      <div *ngFor="let treatment of element.Treatments" class="w-100 pb-2">
                        <div class="expended-title">{{ treatment.Name }}</div>
                        <div class="expended-description">{{ treatment.Description }}</div>
                      </div>                        
                    </ng-container>
                  </div>
                </td>
              </ng-container>

              <!-- Table Rows -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let element; columns: displayedColumns; let index=index; let odd=odd; let even=even;" 
                  class="element-row"
                  [ngClass]="{'even-row': element.even, 'odd-row': !element.even}"
                  [class.expanded-row]="element.ExpendDetails">
              </tr>

              <!-- Expanded Row -->
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" 
              class="detail-row"
              [ngClass]="{'even-row': row.even, 'odd-row': !row.even}"></tr>

            </table>

           

            <div *ngIf="dataSource.data.length === 0" fxLayoutAlign="center" class="m-3 no-data-found-msg">
              {{ 'COMMON.NO-RECORDS-FOUND' | translate }}</div>
          </div>
        </div>
        <mat-error *ngIf="error" fxLayoutAlign="center" class="mt-3 alert alert-danger">{{error}}</mat-error>
      </mat-card-content>
    </mat-card>
  </div>
</div>